module.exports = __webpack_public_path__ + "img/iot2.9e9b215d.png";